<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="3">
                <b-btn variant="primary" @click="create"
                    ><i class="fa fa-plus"></i> Crear Puesto</b-btn
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-client-service-spot-filters
                    :the-client="theClient"
                    :venues="venues"
                    :serviceSpotTypes="serviceSpotTypes"
                    @filter="onFilter"
                    @clear="onClear"
                ></app-client-service-spot-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-client-service-spot-list
                    :items="serviceSpotsFiltered"
                    @delete="onDelete"
                    :service-spot-types="serviceSpotTypes"
                    :venues="venues"
                    @saved="onSave"
                ></app-client-service-spot-list>
            </b-col>
        </b-row>
        <app-pop-up
            title="Formulario de Puesto de Trabajo"
            id="service-spot-form-window"
        >
            <template slot="body">
                <app-client-service-spot-form
                    :the-client="theClient"
                    :item="selectedItem"
                    :venues="venues"
                    :serviceSpotTypes="serviceSpotTypes"
                    @saved="onSave"
                />
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="save"
                    ><i class="fa fa-"></i> Guardar</b-btn
                >
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import ClientServiceSpotList from './ClientServiceSpotList/ClientServiceSpotList'
import ClientServiceSpotFilters from './ClientServiceSpotFilters/ClientServiceSpotFilters'
import ClientServiceSpotForm from './ClientServiceSpotForm/ClientServiceSpotForm'
import serviceSpotRepository from '@repositories/serviceSpot.repository'
import venueRepository from '@repositories/venues.repository'

export default {
    components: {
        appClientServiceSpotList: ClientServiceSpotList,
        appClientServiceSpotFilters: ClientServiceSpotFilters,
        appClientServiceSpotForm: ClientServiceSpotForm,
    },
    props: {
        theClient: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        serviceSpots: [],
        serviceSpotTypeId: '',
        venueId: '',
        selectedItem: null,
        serviceSpotTypes: [],
        venues: [],
    }),
    computed: {
        serviceSpotsFiltered() {
            let spots = !!this.serviceSpotTypeId
                ? this.serviceSpots.filter(
                      item =>
                          item.service_spot_type.id === this.serviceSpotTypeId
                  )
                : [...this.serviceSpots]
            spots = !!this.venueId
                ? spots.filter(item => item.venue_id === this.venueId)
                : [...spots]
            return spots
        },
    },
    methods: {
        async loadServiceSpots() {
            const sr = { ...serviceSpotRepository }
            const { data } = await sr.get({ client: this.theClient.id })
            this.serviceSpots = data
        },
        initialize() {
            this.loadServiceSpots()
            this.loadVenues()
            this.loadServiceSpotTypes()
        },
        async loadVenues() {
            const vr = { ...venueRepository }
            const data = await vr.loadVenuesByClient(this.theClient.id)
            this.venues = data
        },
        async loadServiceSpotTypes() {
            const sr = { ...serviceSpotRepository }
            const { data } = await sr.getTypes()
            this.serviceSpotTypes = data
        },
        onFilter(filters) {
            this.serviceSpotTypeId = filters.serviceSpotTypeId
            this.venueId = filters.venueId
        },
        onClear() {
            this.serviceSpotTypeId = ''
            this.venueId = ''
        },
        onSave(serviceSpot) {
            const serviceSpots = this.serviceSpots.filter(
                item => item.id !== serviceSpot.id
            )
            serviceSpots.push(serviceSpot)
            this.serviceSpots = serviceSpots
            this.loadServiceSpots()
            this.$bus.$emit('service-spot-form-window.close')
        },
        create() {
            this.selectedItem = null
            this.$bus.$emit('service-spot-form-window.open')
        },
        save() {
            this.$bus.$emit('service-spot-form.save')
        },
        onDelete(spot) {
            const spots = this.serviceSpots.filter(item => item.id !== spot.id)
            this.serviceSpots = spots
        },
    },
    created() {
        this.initialize()
    },
}
</script>
